import React, { useState } from 'react';
import { Form, Button, Input, Card, Collapse } from 'antd';
import { User } from '../../models';
import { handleApiExceptions, alertify } from '../../app_methods';
import { EaseModal } from '../../libs/EaseModal';
import { Text1 } from '../../styles';
import ReCAPTCHA from 'react-google-recaptcha';
import { isMobile } from 'react-device-detect';
import { MerchantService } from '../../services';
import "./index.scss";
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';

const recaptchaRef = React.createRef()

let ResetPassword = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const [isSaving, setIsSaving] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;

    const validatePassword = (rule, value, callback) => {
        const new_password = form.getFieldValue("new_password");
        const new_password_repeat = value;
        if (new_password != new_password_repeat) callback("New passwords don't match.");
        else callback();
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (err) return;
            setIsSaving(true);
            MerchantService.reset_password_link({
                unique_code: props.match.params.unique_code,
                new_password: values.new_password
            }).then(response => {
                if (!response.success) {
                    setSuccess(false);
                    setMessage(response.message);
                    setIsSaving(false);
                    return;
                }
                setSuccess(true);
                setMessage("Password changed successfully.");
                setIsSaving(false);
            }).catch(error => {
                setIsSaving(false);
                setSuccess(false);
                setMessage("Something went wrong! Please try again.");
            });
        });
    };

    const handleCaptcha = (key) => {
        setIsDisabled(false);
    }

    return (
        <Card style={{ width: "100%", maxWidth: isMobile ? '-webkit-fill-available' : "380px", margin: "auto", marginTop: "100px" }}>
            <Text1 className="d-block mb-4" strong>Change Password</Text1>
            <Form onSubmit={onSubmit}>
                <Form.Item label="New password">
                    {getFieldDecorator('new_password', {
                        rules: [{
                            required: true, message: "Please enter your new password."
                        }, {
                            pattern: password_regex, message: "Password does not match with policy. Please refer password policy."
                        }]
                    })(<Input type="password" autoComplete='off' />)}
                </Form.Item>
                <Form.Item label="Re-enter New password">
                    {getFieldDecorator('new_password_repeat', {
                        rules: [
                            { required: true, message: "Please re-enter your new password." },
                            { validator: validatePassword }
                        ]
                    })(<Input type="password" autoComplete='off' />)}
                </Form.Item>
                <Collapse className='mb-2' >
                    <CollapsePanel header="Password Policy" key="1">
                        <ul>
                            <li>Password must be at least 8 characters long.</li>
                            <li>Password must contain at least one lowercase letter (a-z).</li>
                            <li>Password must contain at least one uppercase letter (A-Z).</li>
                            <li>Password must contain at least one digit (0-9).</li>
                            <li>Password must contain at least one special character from the set !@#$%^&*.</li>
                        </ul>
                    </CollapsePanel>

                </Collapse>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6Ld6bTgUAAAAAA6oCjg5ABKApovAVcIBARo2Neri"
                    onChange={handleCaptcha}
                />
                <div className="w-100 mt-4">
                    <span className={success ? "justify-content-start text-success" : "justify-content-start text-danger"}>{message}</span>
                    <Button type="primary" htmlType="submit" loading={isSaving} disabled={isDisabled || success} style={{ float: "right" }}>Submit</Button>
                </div>
            </Form>
        </Card>
    )
};

ResetPassword = Form.create()(ResetPassword);

export { ResetPassword };